import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LoadingContext } from '../../contexts';
import DefaultSection, {HorizontalRule} from '../../components/default_section/default_section';
import DefaultInput, { HalfWrapper, SelectOption } from '../../components/default_input/default_input';
import WarningMessage from '../../components/warning_message/warning_message';
import { getCpfText } from '../../utils/functions';
import './patient_data.scss';

class PatientData extends React.Component {
  handleKeyDown(event) {    
    if(event.keyCode === 13 && this.props.enableSave && !this.props.isLoading) {
      this.props.onSave();
    }
  }

  isHighlighted(propertyName) {
    return this.props.highlights.includes(propertyName);
  }

  getClinicOptions() {
    const options = this.props.clinics.filter((clinic) => clinic.is_active || clinic.id === this.props.patient.clinic_id).map((clinic) => SelectOption(clinic.id, clinic.name));

    if (this.props.patient.clinic_id && this.props.patient.clinic_id > 0) {
      return options;
    }

    return [
      SelectOption('', 'Selecione um cliente'),
      ...options
    ];
  }

  getClinicInputLabelMessage() {
    const clinic = this.props.clinics.find((clinic) => clinic.id === this.props.patient.clinic_id);

    if (clinic && !clinic.is_active) {
      return `Cadastro "${clinic.name}" está inativo`;
    }

    if (this.props.isEdit) {
      return null;
    }
    
    return 'Somente cadastros ativos';
  }

  render() {
    return (
      <DefaultSection
        className="patient-data"
        title="Dados do paciente"
      >

        <div className="patient-data__warning-container">

          <WarningMessage
            message={this.props.warningMessage}
            onClose={this.props.onCloseWarning}
            visible={this.props.showWarningMessage}
          />

        </div>

        <div className="patient-data__input-container">

          <DefaultInput
            name="is_active"
            isHighlighted={this.isHighlighted("is_active")}
            label="Ativo:"
            type="toggle"
            isHorizontal={true}
            activeText="Sim"
            inactiveText="Não"
            handleInputChange={this.props.handleInputChange}
            value={this.props.patient.is_active}
            horizontalAlign="right"
            disabled={this.props.isLoading}
          />

          <DefaultInput
            name="clinic_id"
            isHighlighted={this.isHighlighted("clinic_id")}
            label="Cliente"
            labelMessage={this.getClinicInputLabelMessage()}
            type="select"
            handleInputChange={this.props.handleInputChange}
            value={this.props.patient.clinic_id || ''}
            options={this.getClinicOptions()}
            disabled={this.props.isEdit || this.props.isLoading}
          />

          <HalfWrapper>

            <DefaultInput
              name="name"
              isHighlighted={this.isHighlighted("name")}
              label="Nome"
              type="text"
              placeholder="Nome do paciente"
              maxLength="128"
              handleInputChange={this.props.handleInputChange}
              value={this.props.patient.name}
              autoComplete="off"
              onKeyDown={(event) => this.handleKeyDown(event)}
              disabled={this.props.isLoading}
            />

            <DefaultInput
              name="cpf"
              isHighlighted={this.isHighlighted("cpf")}
              label="CPF"
              type="text"
              placeholder="CPF do paciente"
              maxLength="14"
              handleInputChange={this.props.handleInputChange}
              value={getCpfText(this.props.patient.cpf)}
              autoComplete="off"
              onKeyDown={(event) => this.handleKeyDown(event)}
              disabled={this.props.isLoading}
            />

          </HalfWrapper>

          <DefaultInput
            name="notes"
            isHighlighted={this.isHighlighted("notes")}
            label="Notas / Observações"
            type="textarea"
            placeholder="Notas sobre o paciente"
            rows="4"
            handleInputChange={this.props.handleInputChange}
            value={this.props.patient.notes || ''}
            disabled={this.props.isLoading}
          />

        </div>

        <HorizontalRule />

        <div className="patient-data__buttons-container">

          <button
            className="patient-data__save-button"
            disabled={!this.props.enableSave || this.props.isLoading}
            onClick={this.props.onSave}
          >

            Salvar

          </button>

          <Link
            className="patient-data__cancel-button"
            to={this.props.onCancelPath}
            disabled={this.props.isLoading}
          >

            Cancelar

          </Link>

        </div>

      </DefaultSection>
    );
  }
};

const WrappedPatientData = props => {
  const {isLoading} = useContext(LoadingContext);

  return (
    <PatientData
      isLoading={isLoading}
      {...props}
    />
  );
};

export {WrappedPatientData as PatientData};
